module.exports = __webpack_public_path__ + "static/media/5.bc6690f7.jpg";